import {useAccessPayConfiguration, useGet, useQueryWithErrorHandling} from '@app/sdk';

export function useGetReportById({ reportId }: { reportId: string }) {
  const get = useGet();
  const { data: accessPayConfig } = useAccessPayConfiguration();

  async function getReportById() {
    return await get<string>(`${accessPayConfig?.baseUrl}/reports/${reportId}`);
  }

  return useQueryWithErrorHandling({
    queryKey: ['getReportById', reportId],
    queryFn: getReportById,
  });
}
